// Tier-2 <Checkbox> backed by AntD Checkbox (FORT-182). Exposes a clean boolean
// checked/onChange contract (the raw AntD change event is unwrapped). Colour
// comes from the token-sourced AntD global theme — no raw values here.
import React from 'react';
import { Checkbox as AntCheckbox } from 'antd';
import type { CommonProps } from './types';

export interface CheckboxProps extends CommonProps {
  checked?: boolean;
  defaultChecked?: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  children?: React.ReactNode;
}

export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  defaultChecked,
  onChange,
  disabled,
  children,
  className,
  style,
  'data-testid': dataTestId,
}) => (
  <AntCheckbox
    checked={checked}
    defaultChecked={defaultChecked}
    onChange={(e) => onChange?.(e.target.checked)}
    disabled={disabled}
    className={className}
    style={style}
    data-testid={dataTestId}
  >
    {children}
  </AntCheckbox>
);
